/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProjectSelectionCount {
  SINGLE = 'single',
  PER_PARTICIPANT = 'per_participant',
}
